<div class="box">
  <div class="rod"></div>
  <div class="tendon">
    <div class="feather"></div>
  </div>
</div>
